import React from 'react';
import styled from 'styled-components';
import { AiFillLike } from 'react-icons/ai';

import useCollection from '../hooks/useCollection';

export default function TotalLike({ proposalId }) {
  const { documents } = useCollection('likes', 'proposalId', proposalId);

  return (
    <Wrapper>
      <LikeIcon />
      <StyledSpan>{documents ? Object.keys(documents).length : 0}</StyledSpan>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  background-color: #ee7d84;
  color: #fbdfdf;
  border-radius: 2px;
  position: absolute;
  top: 5px;
  right: 65px;
`;

const LikeIcon = styled(AiFillLike)`
  width: 13px;
  height: 13px;
  margin-right: 4px;
`;

const StyledSpan = styled.span`
  margin-bottom: -2px;
  font-weight: 700;
`;
